import { render } from "./PrescriptionDetailsMobileBox2.vue?vue&type=template&id=16a3f544"
import script from "./PrescriptionDetailsMobileBox2.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetailsMobileBox2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__